export enum ActivityCompletionType  {
    None = 0,
    View = 1, // Video, Document, E-Lesson, Exam, Forum, Assignment
    Progress = 2, // Video, E-Lesson
    Complete = 3, // Exam, Survey, E-lesson
    ComposeMessage = 4, // Forum
    DownloadAttachment = 5, // Document, Assignment
    Upload = 6, // Assignment
    AttendLiveSession = 7, // VirtualClass
    ViewRecordedSession = 8, // VirtualClass
    ProgressLive = 9, // VirtualClass
    ProgressLiveOrArchive = 10, // VirtualClass
    Grade = 11, // ALL
    WordCount = 12 // Forum
}